import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { useLocation, Route, Switch } from 'wouter';

import { Container } from './App.Container';
import { Deals, Finder, Home, NotFound, Profile, Rooms, Signup, Step1, Step2, Step3 } from './routes';

const App = () => {
  const [location] = useLocation();

  useEffect(() => {
    const pageShowCallback = (event) => event.persisted && window.Mirai.core(true);

    const interval = setInterval(async () => {
      if (window.Mirai.core) {
        clearInterval(interval);
        await window.Mirai.core();
        const { components = [], ready } = window.Mirai;

        if (
          ready &&
          components.filter(({ component } = {}) => ['booking', 'checkout', 'rates'].includes(component).length > 0)
        ) {
          window.addEventListener('pageshow', pageShowCallback);
        }
      }
    }, 100);
    window.scrollTo({ behavior: 'smooth', top: 0 });

    return () => {
      clearInterval(interval);
      window.removeEventListener('pageshow', pageShowCallback);
    };
  }, [location]);

  return (
    <Container>
      <Switch>
        <Route path={'/'} component={Home} />
        <Route path={'/signup'} component={Signup} />
        <Route path={'/profile'} component={Profile} />
        <Route path={'/deals'} component={Deals} />
        <Route path={'/rooms'} component={Rooms} />
        <Route path={'/finder'} component={Finder} />
        <Route path={'/step0-accommodations'} component={undefined} />
        <Route path={'/step1-rates'} component={Step1} />
        <Route path={'/step2-checkout'} component={Step2} />
        <Route path={'/step3-booking'} component={Step3} />
        <Route path="/:location*">{(params) => <NotFound {...params} />}</Route>
      </Switch>
    </Container>
  );
};

createRoot(document.getElementById('app')).render(<App />);
